import { motion } from "framer-motion";
import { KIKI } from "@/constants/testIds";
import { useT, useLang } from "@/lib/i18n";

// Real photos from KIKI's Facebook page (facebook.com/kikicentre) — no text-overlay shots.
// The classroom shot is the highest-res source (720x540); rest are 160x160 grid thumbs
// that Facebook exposes publicly. `object-cover` crops them into the 4:5 tiles cleanly.
const CAMPUS_PHOTOS = [
  { src: "/campus/classroom.jpg", alt: "KIKI students in a classroom seminar at the Sector 75A campus" },
  { src: "/campus/electronics.jpg", alt: "Students soldering circuit boards in the electronics lab" },
  { src: "/campus/welding-lab.jpg", alt: "Students in safety gear inside the welding lab" },
  { src: "/campus/honda-visit.jpg", alt: "KIKI batch on an industry visit to a Honda facility" },
  { src: "/campus/workbench.jpg", alt: "Students working with electronic components at a workbench" },
  { src: "/campus/product-trio.jpg", alt: "Three KIKI students presenting a working assembly" },
];

export function CampusStrip() {
  const t = useT();
  const { lang } = useLang();
  const isHi = lang === "hi";
  return (
    <section data-testid={KIKI.spotlight} className="relative py-10 md:py-16">
      <div className="max-w-[90rem] mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-2 sm:gap-4 mb-6">
          <div className="flex items-baseline gap-4">
            <span className="font-mono text-sm text-muted-foreground">03</span>
            <span className={`label-overline text-muted-foreground ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("campus.overline")}</span>
          </div>
          <span className={`text-lg md:text-2xl font-bold ${isHi ? "font-hindi" : "font-sans"}`}>{t("campus.title")}</span>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-3">
          {CAMPUS_PHOTOS.map((p, i) => (
            <motion.div
              key={p.src}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="aspect-[4/5] overflow-hidden rounded-xl border border-border group bg-muted"
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
